"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * E-Verify Account Service
 * API for management of E-Verify Accounts
 *
 * The version of the OpenAPI document: 1.0.133
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IipWorkItemStatusToJSON = exports.IipWorkItemStatusFromJSONTyped = exports.IipWorkItemStatusFromJSON = exports.IipWorkItemStatus = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var IipWorkItemStatus;
(function (IipWorkItemStatus) {
    IipWorkItemStatus["PENDINGCONFIRMATION"] = "PENDING_CONFIRMATION";
    IipWorkItemStatus["INPROGRESS"] = "IN_PROGRESS";
    IipWorkItemStatus["EMAILSENT"] = "EMAIL_SENT";
    IipWorkItemStatus["CLOSED"] = "CLOSED";
})(IipWorkItemStatus = exports.IipWorkItemStatus || (exports.IipWorkItemStatus = {}));
function IipWorkItemStatusFromJSON(json) {
    return IipWorkItemStatusFromJSONTyped(json, false);
}
exports.IipWorkItemStatusFromJSON = IipWorkItemStatusFromJSON;
function IipWorkItemStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.IipWorkItemStatusFromJSONTyped = IipWorkItemStatusFromJSONTyped;
function IipWorkItemStatusToJSON(value) {
    return value;
}
exports.IipWorkItemStatusToJSON = IipWorkItemStatusToJSON;
